import { Store } from '../../../store/player/types';

/**
 * Clear open 'Worth watching' tooltip countdown .
 */
export const cancelOpenWorthWatchingTooltipCountdown = (store: Store): void => {
  const { openWorthWatchingTooltipCountdown } = store.getState();

  if (openWorthWatchingTooltipCountdown !== null) {
    clearTimeout(openWorthWatchingTooltipCountdown as number);
  }
};
